import { render, staticRenderFns } from "./CircularEconomyPage.vue?vue&type=template&id=31edba50&scoped=true"
import script from "./CircularEconomyPage.vue?vue&type=script&lang=js"
export * from "./CircularEconomyPage.vue?vue&type=script&lang=js"
import style0 from "./CircularEconomyPage.vue?vue&type=style&index=0&id=31edba50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edba50",
  null
  
)

export default component.exports